import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { CameraContext } from '../../context/app-camera-context';
import { Camera, CameraType } from 'react-camera-pro';
import { setAppData } from '../../state/app/actions';
// import uploadFileToBlob from '../../services/azure-storage-blob';
import { UploadUrl } from '../../services/azure-storage-blob';
import axios from 'axios';

function base64toBlob(base64Data, contentType) {
  contentType = contentType || '';
  var sliceSize = 1024;
  var byteCharacters = atob(base64Data);
  var bytesLength = byteCharacters.length;
  var slicesCount = Math.ceil(bytesLength / sliceSize);
  var byteArrays = new Array(slicesCount);

  for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
    var begin = sliceIndex * sliceSize;
    var end = Math.min(begin + sliceSize, bytesLength);

    var bytes = new Array(end - begin);
    for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
      bytes[i] = byteCharacters[offset].charCodeAt(0);
    }
    byteArrays[sliceIndex] = new Uint8Array(bytes);
  }
  return new Blob(byteArrays, { type: contentType });
}

export default () => {
  const [numberOfCameras, setNumberOfCameras] = useState(0);
  // const [image, setImage] = useState(null);
  const [showImage, setShowImage] = useState(false);
  const camera = useRef(null);
  const {
    setOpen,
    containerName,
    image,
    setImage,
    setLoading,
    isLoading,
    setState,
  } = React.useContext(CameraContext);

  const handleClose = (photo) => {
    setOpen(false);
    // setAppData( -> start uploading
    if ((!!image && containerName) || !!photo) {
      setLoading(true);
      let IMAGE = photo || image;
      var matches = IMAGE?.match(/^data:([A-Za-z-+\/]+);base64,(.+)$/);
      var type = matches[1];
      var fileType = type.split('/')[1];
      var buffer = new Buffer(matches[2], 'base64');
      const id = Math.round(+new Date() / 1000); //+ guid
      const fileName = `Camera_${id}` + `.${fileType}`;

      const url = UploadUrl(containerName, fileName);
      axios
        .put(url, buffer, {
          onUploadProgress: (e) => console.log((e.loaded / e.total) * 100, 'progress'),
          headers: {
            'x-ms-blob-type': 'BlockBlob',
          },
        })
        .then((res) => {
          setState({
            fileList: [
              //from images
              {
                uid: '-1',
                name: fileName,
                status: 'done',
                url,
              },
            ],
          });
          setImage(url);
          setLoading(false);
        })
        .catch((e) => {
          console.log(e, 'e');
          setLoading(false);
        });
    }
  };
  return (
    <Wrapper>
      <div
        onClick={() => handleClose(null)}
        style={{
          zIndex: 200,
          position: 'absolute',
          color: 'white',
          padding: '3%',
          left: '40%',
          fontSize: 30,
          cursor: 'pointer',
          // background: 'black',
        }}
      >
        Close
      </div>
      {showImage ? (
        <FullScreenImagePreview
          image={image}
          onClick={() => {
            setShowImage(!showImage);
          }}
        />
      ) : (
        <div style={{ position: 'absolute', height: '100%', width: '100%' }}>
          <Camera
            ref={camera}
            // aspectRatio="cover"
            aspectRatio={window.innerWidth / window.innerHeight}
            numberOfCamerasCallback={setNumberOfCameras}
            errorMessages={{
              noCameraAccessible:
                'No camera device accessible. Please connect your camera or try a different browser.',
              permissionDenied:
                'Permission denied. Please refresh and give camera permission.',
              switchCamera:
                'It is not possible to switch camera to different one because there is only one video device accessible.',
              canvas: 'Canvas is not supported.',
            }}
          />
        </div>
      )}
      <Control>
        <ImagePreview
          image={image}
          onClick={() => {
            setShowImage(!showImage);
          }}
        />
        <TakePhotoButton
          onClick={() => {
            if (camera.current) {
              const photo = camera.current.takePhoto();
              setImage(photo);
              handleClose(photo);
            }
          }}
        />
        <ChangeFacingCameraButton
          disabled={numberOfCameras <= 1}
          onClick={() => {
            if (camera.current) {
              const result = camera.current.switchCamera();
            }
          }}
        />
      </Control>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background: grey;
  z-index: 100;
`;

const Control = styled.div`
  position: fixed;
  display: flex;
  right: 0;
  width: 20%;
  min-width: 130px;
  min-height: 130px;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 50px;
  box-sizing: border-box;
  flex-direction: column-reverse;

  @media (max-aspect-ratio: 1/1) {
    flex-direction: row;
    bottom: 0;
    width: 100%;
    height: 20%;
  }

  @media (max-width: 400px) {
    padding: 10px;
  }
`;

const Button = styled.button`
  outline: none;
  color: white;
  opacity: 1;
  background: transparent;
  background-color: transparent;
  background-position-x: 0%;
  background-position-y: 0%;
  background-repeat: repeat;
  background-image: none;
  padding: 0;
  text-shadow: 0px 0px 4px black;
  background-position: center center;
  background-repeat: no-repeat;
  pointer-events: auto;
  cursor: pointer;
  z-index: 2;
  filter: invert(100%);
  border: none;

  &:hover {
    opacity: 0.7;
  }
`;

const TakePhotoButton = styled(Button)`
  background: url('https://img.icons8.com/ios/50/000000/compact-camera.png');
  background-position: center;
  background-size: 50px;
  background-repeat: no-repeat;
  width: 80px;
  height: 80px;
  border: solid 4px black;
  border-radius: 50%;

  &:hover {
    background-color: rgba(0, 0, 0, 0.3);
  }
`;

const ChangeFacingCameraButton = styled(Button)`
  background: url(https://img.icons8.com/ios/50/000000/switch-camera.png);
  background-position: center;
  background-size: 40px;
  background-repeat: no-repeat;
  width: 40px;
  height: 40px;
  padding: 40px;
  &:disabled {
    opacity: 0;
    cursor: default;
    padding: 60px;
  }
  @media (max-width: 400px) {
    padding: 40px 5px;
    &:disabled {
      padding: 40px 25px;
    }
  }
`;

const ImagePreview = styled.div`
  width: 120px;
  height: 120px;
  ${({ image }) => (image ? `background-image:  url(${image});` : '')}
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;

  @media (max-width: 400px) {
    width: 50px;
    height: 120px;
  }
`;

const FullScreenImagePreview = styled.div`
  width: 100%;
  height: 100%;
  z-index: 100;
  position: absolute;
  background-color: black;
  ${({ image }) => (image ? `background-image:  url(${image});` : '')}
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`;
